import { gql } from "@apollo/client";

// ============================================================================
// PAGE QUERIES
// ============================================================================

import {
  GENERAL_FIELDS,
  SITE_FIELDS,
  PAGE_SETTINGS,
  BUTTON_RECORD,
  BUTTON_EXTERNAL_RECORD,
  DOWNLOAD_BUTTON_RECORD,
  HUBSPOT_BUTTON_RECORD,
  FOOTER_OVERRIDES,
} from "./shared";
import { SECTIONS_WRAPPER_QUERY } from "./fragments/sections";

export const PAGE_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${PAGE_SETTINGS}
  ${SECTIONS_WRAPPER_QUERY}
  ${BUTTON_RECORD}
  ${BUTTON_EXTERNAL_RECORD}
  ${DOWNLOAD_BUTTON_RECORD}
  ${HUBSPOT_BUTTON_RECORD}
  ${FOOTER_OVERRIDES}
  query GetPage($slug: String!, $locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: page(filter: { slug: { eq: $slug } }, locale: $locale) {
      # Page Meta (SEO)
      slugs: _allSlugLocales(locale: $locale) {
        locale
        value
      }
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # Page Fields (Content)
      title
      shortTitle
      callToActions {
        __typename
        ... on ButtonRecord {
          ...ButtonBlock
        }
        ... on ButtonExternalRecord {
          ...ButtonExternalBlock
        }
        ... on DownloadButtonRecord {
          ...DownloadButtonBlock
        }
        ... on HubspotButtonRecord {
          ...HubspotButtonBlock
        }
      }

      intro {
        value
      }

      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }

      # Page Components
      pageSettings {
        ...PageSettings
      }
      sections {
        ...SectionWrapperQuery
      }

      # Footer overrides
      footerOverrides {
        ...FooterOverrides
      }
    }
  }
`;
